import SvgArrow from 'assets/secure-financing/arrow-right.inline.svg';
import { Link } from 'gatsby';
import React from 'react';
import tw, { css } from 'twin.macro';

const cssLink = css`
	${tw`leading-12 text-grey-1 sm:ml-07`};	
	cursor: pointer;

  .visible-on-hover {
    visibility: hidden;
  }

	:hover {
		${tw`text-green-1`}
    .visible-on-hover {
      visibility: visible;
    }
	}
`;

const cssArrow = css`
	${tw`inline ml-02`};
`;

export default function SourceLink({ to, children }) {
	return (
		<Link to={to} target="_blank" css={[ cssLink ]}>
			{children}
			<span className='visible-on-hover'>
				<SvgArrow css={[ cssArrow ]} />
			</span>
		</Link>
	);
}
